import React, { useState } from "react";
import style from "./contact.module.css";
export default function Contact() {
  const [name, setname] = useState("");
  const [email, setemail] = useState("");

  return (
    <div className={style.mainCard}>
      <div className={style.innerCard}>
        <div className={style.text}>
          <p className={style.normal}>Have an idea to discuss?</p>
          <p className={style.big}>
            <strong>Schedule</strong> a free <strong>30</strong> mins call
          </p>
        </div>
        <div className={style.form}>
          <form>
            <input
              className={style.input}
              value={name}
              onChange={e => setname(e.target.value)}
              placeholder="Name"
            ></input>
            <input
              className={style.input}
              value={email}
              onChange={e => setemail(e.target.value)}
              placeholder="Email"
            ></input>
            <button
              className={style.btn}
              type="submit"
              onClick={e => e.preventDefault()}
            >
              <img
                src="https://invozone.com/wp-content/uploads/2020/04/paper-arrow.svg"
                alt="Arrow"
                className={style.btnArrow}
              ></img>
              Schedule
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
